
interface EnvType {
    REACT_APP_BASE_AUTH: string;
}

const env = process.env as unknown as EnvType;
const baseUrlWeb = env.REACT_APP_BASE_AUTH;

export default baseUrlWeb;
